var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelProLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#5D5FEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7123 17.9786C28.0352 18.2653 28.6634 19.0251 28.5929 19.7705C28.5225 20.516 28.5636 26.0867 28.5929 28.7866L36.8708 21.9925C37.8982 21.5147 40.1644 21.1467 41.0098 23.4978V44.2844V49L36.8708 45.5746L29.6497 39.7687C29.2974 39.5536 28.5929 38.8655 28.5929 37.8334V28.7866L20.3151 35.5397C19.2877 35.9697 17.0039 36.3281 16.0881 34.3211L16 13.4626V8L27.7123 17.9786Z",
    fill: "url(#paint0_linear_3685_2155)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6387,
    y: 27.2097,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6758,
    y: 27.7831,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2324,
    y: 16.6014,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0781,
    y: 27.7831,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0781,
    y: 32.8006,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2324,
    y: 27.2097,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0781,
    y: 37.818,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6758,
    y: 37.818,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6758,
    y: 32.8006,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2324,
    y: 21.9055,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6387,
    y: 21.9055,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6387,
    y: 16.6014,
    width: 2.1135,
    height: 2.58041,
    fill: "#4F57F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3685_2155",
    x1: 28.5049,
    y1: 11.5839,
    x2: 28.5049,
    y2: 46.0123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelProLogo);
export default __webpack_public_path__ + "static/media/hotelProLogo.1df81796ce90c0b952b677921c0dfeb8.svg";
export { ForwardRef as ReactComponent };